<!-- Content -->
<div [blockUi]="[
     {blocked: (historySharedFacade.entityHasSnapshotItems$(node) | async) || false, iconClass: 'warning'}
     ]">
  @if ({currentIsLoading: (textExportAuthorFacade.currentIsLoading$ | async), currentHasLoaded: (textExportAuthorFacade.currentHasLoaded$ | async)}; as textExportData) {
    <!-- Load Button -->
    <button medsurf-design-input-button [id]="'export_load_content'"
      class="mb-2"
      [label]="(textExportData.currentHasLoaded ? 'global.contents_reload' : 'global.contents_load') | translate"
      [disabled]="textExportData.currentIsLoading"
    (click)="load()"></button>
    <!-- Process Spinner -->
    @if (textExportData.currentIsLoading === true) {
      <medsurf-design-content-process-spinner></medsurf-design-content-process-spinner>
    }
    <!-- Text Export Content -->
    @if (textExportData.currentIsLoading === false) {
      <!-- Nothing To Show -->
      @if (textExportData.currentHasLoaded === true && textExportObjectCount === 0) {
        <p>{{'global.no_data_to_export' | translate}}</p>
      }
      <!-- Download Form -->
      @if (textExportObjectCount > 0) {
        <!-- Form -->
        @if (exportForm) {
          <medsurf-design-form-control-form
            [formGroup]="exportForm"
            (onSubmit)="onSubmit()">
            <!-- Display Type -->
            <medsurf-design-form-control-input-select-button [control]="exportForm.controls.displayType"
              [label]="'global.text_export'"
              [options]="FlatModels.TextExportAuthorModels.TextExportDisplayTypeArray"
              [allowEmpty]="false"
            (valueChange)="onSubmit()"></medsurf-design-form-control-input-select-button>
            <!-- Html Tags -->
            <medsurf-design-form-control-input-switch [formField]="false"
              [control]="exportForm.controls.htmlTags"
              [label]="'global.keep_html_tags'"
            (valueChange)="onSubmit()"></medsurf-design-form-control-input-switch>
          </medsurf-design-form-control-form>
        }
        <div class="text-sm p-3 surface-900 mb-2">
          <pre class="overflow-hidden h-24rem m-0" style="white-space: pre-wrap; mask-image: linear-gradient(black, transparent);">{{textExcerpt()}}</pre>
        </div>
        <div class="flex flex-row column-gap-2">
          <button medsurf-design-input-button [id]="'download'"
            [label]="'global.download' | translate"
          (click)="download()"></button>
          <button medsurf-design-input-button [id]="'copy'" (click)="clipboardAuthorFacade.requestCopyToClipboard(text())"
            [label]="'global.copy' | translate"></button>
        </div>
      }
    }
  }
</div>
